import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BookingService } from '@app/listing/services/booking.service';
import SiteVisitViewModel from '@app/models/site-visit-view-model';
import { NotificationService, WorkflowService } from '@app/services';
import { Subscription } from 'rxjs';
import { SiteVisitService } from '../../../../services/site-visit.service';
import { NewlineToParagraphPipe } from '../../../../shared-components/pipes/newline-to-paragraph.pipe';
import { SpinnerComponent } from '../../../../common-components/spinner/spinner.component';
import { NgIf } from '@angular/common';

@Component({
    selector: "site-visit-terms-conditions",
    templateUrl: "./site-visit-terms-conditions.component.html",
    styleUrls: ["./site-visit-terms-conditions.component.less"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, SpinnerComponent, NewlineToParagraphPipe]
})
export class SiteVisitTermsConditionsComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'SiteVisitTermsConditionsComponent';

  /**
   * Component data sources and properties are being initialized
   */
  public initializing = true;

  public loading = false;

  public landOwnerTerms: {
    propertyRules?: string;
  };

  private workflowName = 'ScheduleOnly Booking Workflow';
  private workflowStepName = 'tc';

  public oaTermsAndConditionText =
    'Members must obey all applicable local, state, and federal laws. Where required, members must purchase appropriate recreational licenses and observe seasonal restrictions on recreation. Members must register all adult guests under their lease with Outdoor Access. All lease users must have a valid permission pass with them throughout the entirety of their lease.';

  public siteVisit: SiteVisitViewModel;
  private siteVisit$: Subscription;

  constructor(
    readonly route: ActivatedRoute,
    readonly changeDetectorRef: ChangeDetectorRef,
    readonly bookingService: BookingService,
    private siteVisitService: SiteVisitService,
    private notify: NotificationService,
    private workflowService: WorkflowService
  ) {
    console.log(`${this._componentName}.CTOR`);

    this.siteVisit$ = this.siteVisitService.siteVisit.subscribe(
      (model) => {
        this.setModel(model);
      },
      (err) => {
        console.error(err);
        
        this.notify.error('A subscription error occured', null);
      }
    );
  }

  ngOnInit() {}

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {
    if (this.siteVisit$) {
      this.siteVisit$.unsubscribe();
    }
  }

  private setModel(model: SiteVisitViewModel) {
    console.log(`${this._componentName}.setModel `); 
    if (model) {
      this.landOwnerTerms = {
        propertyRules: model.propertyRules || '',
      };

      this.initializing = false;

      this.siteVisit = model;

      this.changeDetectorRef.markForCheck();
    }
  }

  public onAgreeClick() {
    this.workflowService.stepIsReadyToBeMarkedCompleted(this.workflowName, this.workflowStepName);

    // this.bookingService.stepCompleted.next(this.route.snapshot.url[0].path);
  }
}
